import React from 'react';
import {useRoulette} from "../../../store/roulette/RouletteContext";
import HistoryMobile from "./HistoryMobile";

const ResultHistoryMobile = () => {
    const props = useRoulette()
    return (
        <div>
            <div className="roulette-mobile-history">
                <HistoryMobile {...props} />
            </div>
        </div>
    );
};

export default ResultHistoryMobile;